<!--
 * @Author: your name
 * @Date: 2020-03-24 15:00:14
 * @LastEditTime: 2020-03-31 16:01:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlonmarinesite\src\pages\pdf.vue
 -->
 <template>
  <iframe id="iframerd" :src="lmmadrdUrl" width="100%" height="100%"></iframe>
</template>
  <script>
import Vue from "vue";
export default {
  name: "Pdf",
  mounted() {
    //  let basetConfig = Vue.prototype.baseConfig
    //    console.log(lmmadsrc)
    //  console.log(basetConfig)
    //this.$route.query.winURL
    this.lmmadrdUrl = lmmadrdsrc;
    const iframebox = document.getElementById("iframerd");
    const deviceWidth = document.documentElement.clientWidth;
    const deviceHeight = document.documentElement.clientHeight;
    iframebox.style.width = Number(deviceWidth) + "px";
    iframebox.style.height = Number(deviceHeight) - 50 + "px";
  },
  components: {},
  data() {
    return {
      lmmadrdUrl: ""
    };
  }
};
</script>
  


// WEBPACK FOOTER //
// src/pages/rdcj.vue